import { recommended as commonRecommended } from '../common/actions.js';

export const recommended = [...commonRecommended];
